export const walletsStatisticPath = 'wallets-statistic';
